/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WebPagesIndexRouteImport } from './routes/web-pages/index'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as DocumentsIndexRouteImport } from './routes/documents/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WebPagesIndexRoute = WebPagesIndexRouteImport.update({
  id: '/web-pages/',
  path: '/web-pages/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsIndexRoute = DocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/web-pages/': typeof WebPagesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/documents': typeof DocumentsIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/web-pages': typeof WebPagesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/web-pages/': typeof WebPagesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/documents/' | '/reports/' | '/web-pages/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/documents' | '/reports' | '/web-pages'
  id: '__root__' | '/' | '/documents/' | '/reports/' | '/web-pages/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DocumentsIndexRoute: typeof DocumentsIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  WebPagesIndexRoute: typeof WebPagesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/web-pages/': {
      id: '/web-pages/'
      path: '/web-pages'
      fullPath: '/web-pages/'
      preLoaderRoute: typeof WebPagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/': {
      id: '/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof DocumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DocumentsIndexRoute: DocumentsIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  WebPagesIndexRoute: WebPagesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
